import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography, List, ListItem} from '@material-ui/core';
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'
import UpdatePage from '../components/UpdatePage'
import LargeServiceCard from '../components/LargeServiceCard'
import HeaderImg from '../components/HeaderImg'
import services_ph from '../images/services_ph.jpg'
import services_mobile from '../images/services_small.jpg'
import services_desktop from '../images/services_med.jpg'
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import CustomList from '../components/CustomList';

import audits_400 from '../images/audits_small.jpg'
import audits_750 from '../images/audits_med.jpg'
import audits_1250 from '../images/audits_large.jpg'
import investigative_400 from '../images/investigative_small.jpg'
import investigative_750 from '../images/investigative_med.jpg'
import investigative_1250 from '../images/investigative_large.jpg'
import process_400 from '../images/process_small.jpg'
import process_750 from '../images/process_med.jpg'
import process_1250 from '../images/process_large.jpg'
import regulatory_400 from '../images/regulatory_small.jpg'
import regulatory_750 from '../images/regulatory_med.jpg'
import regulatory_1250 from '../images/regulatory_large.jpg'

import audits_ph from '../images/audits_ph.jpg'
import investigative_ph from '../images/investigative_ph.jpg'
import process_ph from '../images/process_ph.jpg'
import regulatory_ph from '../images/regulatory_ph.jpg'

const useStyles = makeStyles((theme) => ({
    listBorder: {
        borderRight: '1px solid #bfbfbf',
        [theme.breakpoints.only('xs')]: {
            borderRight: 0,
            borderBottom: '1px solid #bfbfbf',
        }
    },
    descriptionPadding: {
        [theme.breakpoints.up('sm')]: {
            '& p': {
                paddingLeft: theme.spacing(4),
            },
        },
        [theme.breakpoints.down('xs')]: {
            '& p:first-child': {
                paddingTop: theme.spacing(2),
            }
        }
    }
}))

export default function Services() {
    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <ScrollToTopOnMount />
            <UpdatePage title='RQuaL Solution - Consultation Services for Quality Compliance & Regulatory Support' />
            <Grid item xs={12}>
                <HeaderImg ph={services_ph} srcMobile={services_mobile} srcDesktop={services_desktop} />
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 1, md: 2 }} mb={{ xs: 1, md: 2 }}>
                    Our Bespoken Services
                </Box>
                <Typography align='justify' paragraph={true}>
                    In the live regulatory scenario, consistent GMP &amp; Regulatory compliance on a day to day basis makes a good business sense. 
                    Industry finds it tough to consistently sustain compliance standards along with rigorous regulatory/customer inspections of the facilities and GMP systems.
                </Typography>
                <Typography align='justify' paragraph={true}>
                    We customize our project plan for you based on our understanding of the global regulatory landscape and proven expertise within the Pharmaceutical Industry.
                    With top-caliber professionals in the industry, we can set our foot on the War Ground and provide end-to-end customized solutions for a project.
                </Typography>
                <Typography align='justify' paragraph={true}>
                    <b>RQuaL</b> has the capability and potential to handle any level of project. We can integrate seamlessly with your team and work as per their requirements to provide a workable solution that the team can accomplish in a time bound manner. We believe in working with your team to get the maximum output in the shortest possible timeline.
                </Typography>
                <Typography align='justify' paragraph={true}>
                    <b>RQuaL</b> promises to stand by you with its <b>"Auditing Services"</b> to meet the stringent current regulations of various authorities. Our experts with decades of ground experience in auditing/inspection can provide you with high standard compliance audit findings and customized ready-to-use solutions. <b>RQuaL helps</b> to prepare the team and enhance their compliance standards to succeed during a Regulatory Inspection.
                </Typography>
                <Typography align='justify' paragraph={true}>
                    RQuaL ensures to get the right set of experts on ground to do a GEMBA and provide Customized &amp; Practical Solution.
                </Typography>
            </Grid>
            <Grid item xs={12} id="audits">
                <LargeServiceCard heading="Audits" ph={audits_ph}
                    src={[audits_400, audits_750, audits_1250]}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} md={4} lg={3} className={classes.listBorder}>
                            <List disablePadding={true} dense={true}>
                                <ListItem disableGutters>1. Site Due Diligence</ListItem>
                                <ListItem disableGutters>2. Initial Facility Designing</ListItem>
                                <ListItem disableGutters>3. Improvements in Facility Design</ListItem>
                                <ListItem disableGutters>4. HVAC Systems</ListItem>
                                <ListItem disableGutters>5. Water Systems</ListItem>
                                <ListItem disableGutters>6. Equipment Selection/Optimization</ListItem>
                                <ListItem disableGutters>7. Qualifications and Validations</ListItem>
                                <ListItem disableGutters>8. Vendor Audits and Qualification</ListItem>
                                <ListItem disableGutters>9. Vendor Evaluation</ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={7} md={8} lg={9} className={classes.descriptionPadding}>
                            <Typography align='justify' paragraph={true}>RQuaL has the expertise to perform full Site Due Diligence for assessing a facility on gaps and risks associated with historical activities related to GMP.</Typography>
                            <Typography align='justify' paragraph={true}>We assist the organizations to build GMP into systems by assessing the design at the initial stage so that the system can sustain all the Green Regulations. We also do retrospective assessment of the facility design for upgrading and meeting the current audit expectations. Our team has the expertise to support complex matters of HVAC/Water system design.</Typography>
                            <Typography align='justify' paragraph={true}>We help in the selection of the right Equipment / Instruments for the facility and their Qualifications and Validations as per the current guidelines.</Typography>
                            <Typography align='justify' paragraph={true}>Vendor selection is the key to First Time Right product. We assist in Vendor audits for Key Starting materials, Intermediates, Active Pharmaceutical Ingredients, Excipient, Primary Packaging material. We also undertake audits of Finished dosage form manufacturers, Research and Development Labs, Analytical laboratories, Distributors, Transporters etc.</Typography>

                        </Grid>
                    </Grid>
                </LargeServiceCard>
            </Grid>
            <Grid item xs={12} id="investigative">
                <LargeServiceCard heading="Investigative Activities" ph={investigative_ph}
                    src={[investigative_400, investigative_750, investigative_1250]}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} md={4} lg={3} className={classes.listBorder}>
                            <List disablePadding={true} dense={true}>
                                <ListItem disableGutters>1. Documentation, DI Review</ListItem>
                                <ListItem disableGutters>2. Troubleshooting & Risk Analysis</ListItem>
                                <ListItem disableGutters>3. Investigations and RCA</ListItem>
                                <ListItem disableGutters>4. CAPA Management</ListItem>
                                <ListItem disableGutters>5. Quality Risk Management</ListItem>
                                <ListItem disableGutters>6. Preparing Internal Auditors</ListItem>
                                <ListItem disableGutters>7. GxP System Improvements</ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={7} md={8} lg={9} className={classes.descriptionPadding}>
                            <Typography align='justify' paragraph={true}>RQuaL helps the organizations to do investigations and Risk analysis for various activities critical to GMP and Product Quality. We help in GEMBA walks along with the local site team and do the Investigations, Troubleshooting, Risk based Root Cause analysis and assist in developing CAPA as per specific requirements.</Typography>
                            <Typography align='justify' paragraph={true}>We also undertake projects to groom internal Auditors with the skills required to audit and do self assessments for Site GxP Improvements.</Typography>
                        </Grid>
                    </Grid>
                </LargeServiceCard>
            </Grid>
            <Grid item xs={12} id="process">
                <LargeServiceCard heading="Process Optimisation" ph={process_ph}
                    src={[process_400, process_750, process_1250]}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} md={4} lg={3} className={classes.listBorder}>
                            <List disablePadding={true} dense={true}>
                                <ListItem disableGutters>1. cGMP Automation Software</ListItem>
                                <ListItem disableGutters>2. Training Process Setup</ListItem>
                                <ListItem disableGutters>3. Specialized Subject Training</ListItem>
                                <ListItem disableGutters>4. Aseptic Processing Compliance</ListItem>
                                <ListItem disableGutters>5. Sterilizations</ListItem>
                                <ListItem disableGutters>6. Advanced Manufacturing</ListItem>
                                <ListItem disableGutters>7. Operation Excellence / PAT</ListItem>
                                <ListItem disableGutters>8. Analytical technology</ListItem>
                                <ListItem disableGutters>9. Analytical Services Optimization</ListItem>
                                <ListItem disableGutters>10. Technology Transfer</ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={7} md={8} lg={9} className={classes.descriptionPadding}>
                            <Typography align='justify' paragraph={true}>RQuaL assists the organizations for Optimizing their current processes and GxP activities. </Typography>
                            <Typography align='justify' paragraph={true}>Training has always been the core to Growth of an organization. We help in developing the optimum training process for the organization as per the company setup.</Typography>
                            <Typography align='justify' paragraph={true}>RQuaL specializes in both Sterile and Non-Sterile process activities. We set up the growth process in the organization using the Advance Manufacturing module, leading to Operational Excellence. We also help in setting up Analytical Labs and Process Analytical Technology for complex processes.</Typography>
                        </Grid>
                    </Grid>
                </LargeServiceCard>
            </Grid>
            <Grid item xs={12} id="regulatory">
                <LargeServiceCard heading="Regulatory Support" ph={regulatory_ph}
                    src={[regulatory_400, regulatory_750, regulatory_1250]}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} md={4} lg={3} className={classes.listBorder}>
                            <List disablePadding={true} dense={true}>
                                <ListItem disableGutters>1. Regulatory Filing</ListItem>
                                <ListItem disableGutters>2. Maintenance and Responses</ListItem>
                                <ListItem disableGutters>3. Regulatory Compliance</ListItem>
                                <ListItem disableGutters>4. Pre-Inspection Audit</ListItem>
                                <ListItem disableGutters>5. Regulatory Audit Preparedness</ListItem>
                                <ListItem disableGutters>6. Site Readiness</ListItem>
                                <ListItem disableGutters>7. Team Building - SMEs</ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={12} sm={7} md={8} lg={9} className={classes.descriptionPadding}>
                            <Typography align='justify' paragraph={true}>We take up DMF preparation for specific regulatory bodies by getting involved from the very beginning of the planning stage to the final DMF filing. We also help in Maintenance and formulating optimized responses to the Authorities on the queries raised on the filed DMFs.</Typography>
                            <Typography align='justify' paragraph={true}>We help the sites in developing processes to comply with the filed DMFs and do regular audits for compliance verification. </Typography>
                            <Typography align='justify' paragraph={true}>We do undertake projects on preparing the site for Regulatory Audits. We help in developing the Site Subject Matter Experts who will be confident in handling all the audits.</Typography>
                            <Typography align='justify' paragraph={true}>RQuaL has the expertise to perform Pre-audits to assure site readiness for Health Authorities Inspections.</Typography>

                        </Grid>
                    </Grid>
                </LargeServiceCard>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 1, md: 2 }} mb={{ xs: -1, md: -1 }}>
                    Our Key Strengths
                </Box>
            </Grid>
            <Grid item container>
                <Grid item xs={12} md={6}>
                    <CustomList
                        bulletIcon={<LabelImportantIcon/>}
                        listText={[
                            "Rich Industrial Experience in Quality Compliance and Regulatory Affairs",
                            "Thorough understanding of Regulations and Guidelines",
                            "Expertise in Global Regulatory Strategy and Operations",
                            "Project Approach",
                            "Integrate seamlessly with the Ground team",
                            "Provide cost effective Customized, Workable and Sustainable solutions"]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <CustomList 
                        bulletIcon={<LabelImportantIcon/>}
                        listText={[
                            "Regular Monitoring of CAPA",
                            "Time-bound Project completion",
                            "Data Integrity Compliances",
                            "Process Optimization - Operational Excellence ",
                            "Health Authority Enforcement Action Response and Remediation",
                            "Coaching and Mentoring"]} 
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 1, md: 2 }} mb={{ xs: 1, md: 2 }}>
                    Project Implementation
                </Box>
                <Typography align='justify' paragraph={true}>
                    <b>RQuaL</b> believes in providing wholesome solutions to our valued clients and puts all efforts in building long lasting relationships.
                </Typography>
                <Typography align='justify'>We don’t just advise on how to achieve a successful outcome but promise to work alongside the <b>Ground Team</b> to get the Project accomplished in a <b>Time Bound manner</b>.</Typography>
            </Grid>
        </Grid>
    )
}